class ClickForCredits extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'summary']
  }

  connectedCallback () {
    super.connectedCallback()

    this.summaryHeight = this.getSummaryHeight()

    this.setMaxHeight()
  }

  setMaxHeight () {
    this.style.setProperty(
      '--Max_Height',
      `${this.summaryHeight}px`,
    )
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
  }

  onTriggerClick () {
    this.isOpen = !this.isOpen
  }

  getSummaryHeight () {
    const summary = this.els.summary.element
    summary.style.maxHeight = 'none'

    const height = summary.offsetHeight
    summary.style.removeProperty('max-height')

    return height
  }

  get isOpen () {
    return this.hasAttribute('open')
  }

  set isOpen (val) {
    val ? this.setAttribute('open', '') : this.removeAttribute('open')

    this.els.summary.element.setAttribute('aria-expanded', val.toString())
  }
}

if (!customElements.get('click-for-credits')) {
  customElements.define('click-for-credits', ClickForCredits)
}
